import React from 'react';
import { Box, Avatar, Typography, Chip } from '@mui/material';
import ProductTools from './ProductTools';

const ImageInfosProduit = ({ produit }) => {
  return (
    <Box sx={{
      flex: { xs: 'unset', md: '0 0 180px' },
      bgcolor: '#f8fafc',
      p: 2.5,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      borderRight: { md: '1px solid #e3e6ef' },
      minWidth: 150,
      gap: 1
    }}>
      <Avatar
        variant="rounded"
        src={produit.ASIN ? `https://images-na.ssl-images-amazon.com/images/P/${produit.ASIN}.01._SCLZZZZZZZ_.jpg` : ''}
        alt={produit.Titre}
        sx={{ width: 64, height: 64, mb: 1, bgcolor: '#f5f5f5', border: '1px solid #eee' }}
      />
      <Typography variant="subtitle2" sx={{ fontWeight: 700, textAlign: 'center', mb: 0.5, fontSize: '1rem' }}>{produit.Titre}</Typography>
      <Typography variant="caption" sx={{ color: '#888' }}>ASIN : {produit.ASIN || '-'}</Typography>
      <Typography variant="caption" sx={{ color: '#888' }}>EAN : {produit.EAN || '-'}</Typography>
      <Chip
        label={produit.Actif ? 'Actif' : 'Non Actif'}
        color={produit.Actif ? 'success' : 'error'}
        size="small"
        sx={{ fontWeight: 600, minWidth: 70, mt: 1 }}
      />
      {produit.ASIN && (
        <Box sx={{ mt: 1 }}>
          <ProductTools asin={produit.ASIN} countryCode="FR" />
        </Box>
      )}
    </Box>
  );
};

export default ImageInfosProduit; 